<script setup lang="ts">
import { Head, usePage } from "@inertiajs/vue3";

defineOptions({ inheritAttrs: false });
const page = usePage();
</script>

<template>
  <Head title="Migration in progress" />

  <main class="page-container-tight page-section">
    <h1 class="text-2xl font-semibold tracking-tight">Vue migration in progress</h1>
    <p class="mt-3 text-sm text-muted-foreground">
      The page
      <code class="rounded bg-muted px-1 py-0.5 text-xs">{{ page.component }}</code>
      does not have a Vue component yet.
    </p>
    <p class="mt-2 text-sm text-muted-foreground">
      Create
      <code class="rounded bg-muted px-1 py-0.5 text-xs"
        >/Users/turbopila/lab/condor/app/frontend/pages/{{ page.component }}.vue</code
      >
      to replace this placeholder.
    </p>
  </main>
</template>
